export default function isOutside(value, range) {
  return !!(range[0] && range[1] && (value < range[0] || value > range[1]));
}
